var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.generators),function(generator,index){return _c('css-injector',{key:index,attrs:{"generator":generator}})}),_c('div')],2)}
var staticRenderFns = []

export { render, staticRenderFns }